import { createSlice } from "@reduxjs/toolkit";

const normalizeLang = (value) => String(value || '').toLowerCase().startsWith('ar') ? 'ar' : 'en';
const getLangLabel = (value) => normalizeLang(value) === 'ar' ? 'عربي' : 'English';

const getInitialLangState = () => {
    try {
        const storedLang =
            localStorage.getItem('preferredLang') ||
            localStorage.getItem('i18nextLng') ||
            localStorage.getItem('appLang');
        const normalizedLang = normalizeLang(storedLang || 'ar');
        return {
            label: getLangLabel(normalizedLang),
            value: normalizedLang
        };
    } catch {
        return {
            label: 'عربي',
            value: 'ar'
        };
    }
};

const langSlice = createSlice({
    name: 'lang',
    initialState: getInitialLangState(),
    reducers:{
        setLang: (state,action) => {
            const normalizedLang = normalizeLang(action?.payload?.value);
            state.label = action?.payload?.label || getLangLabel(normalizedLang);
            state.value = normalizedLang;
            try {
                localStorage.setItem('preferredLang', normalizedLang);
                localStorage.setItem('i18nextLng', normalizedLang);
                localStorage.setItem('appLang', normalizedLang);
            } catch {
            }
        }
    }
})

export const {setLang} = langSlice.actions;
export default langSlice.reducer
